var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-breadcrumb',{attrs:{"items":_vm.breadcrumbs}}),_c('div',{staticClass:"view-container"},[(_vm.showLoader)?_c('div',[_c('app-loader',{attrs:{"fadeoutLoader":_vm.fadeoutLoader}})],1):_vm._e(),(_vm.fadeoutLoader)?_c('div',[_c('app-banner'),_c('app-bottom-banner')],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }